<template>
  <el-autocomplete
      style="width: 100%"
      @input="$emit('change', value);"
      class="inline-input"
      v-model="value"
      :fetch-suggestions="querySearch"
      :placeholder="placeholder"
      clearable
      @select="handleSelect"
      :disabled="disabled"
      :trigger-on-focus="true"
  ></el-autocomplete>
</template>

<script>
export default {
  name: 'InputAutoTip',
  props: {
    inputValue: String,
    placeholder: String,
    tipList: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    this.value = this.inputValue;
  },

  data() {
    return {
      restaurants: [],
      value: '',
      refresh: false, // 新增一个用于刷新组件的标记
    };
  },
  model: {
    prop: 'inputValue',
    event: 'change'
  },
  watch: {
    inputValue() {
      this.value = this.inputValue;
    },
    tipList: {
      handler(newVal) {
        this.restaurants = this.loadAll();
        this.refresh = !this.refresh; // 切换刷新标记
      },
      deep: true,
    },
  },
  methods: {
    querySearch(queryString, cb) {
      const restaurants = this.restaurants;
      const results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value?.toLowerCase()?.indexOf(queryString.toLowerCase()) !== -1);
      };
    },
    loadAll() {
      return this.tipList?.map(item => ({value: item}));
    },
    handleSelect(item) {
      // 选中条目后的逻辑
    }
  },
  mounted() {
    this.restaurants = this.loadAll();
  }
};
</script>

<style scoped></style>
